import { Container, Text } from '@pixi/react'
import { Image, t, Button, FeatureToggleV2Type, soundManager, SoundType, useFeatureToggleV2, language } from '@slot-nx/core'
import { TextStyle, Container as PixiContainer, Text as PixiText } from 'pixi.js'
import { useEffect, useRef, useState } from 'react'
import { winningService } from '../domain/winning/WinningService'
import { usePopupStore } from '../domain/popup/popupStore'
import { threecomboolympusMachine } from '../domain/machine/threecomboolympusMachine'
import { GameStatus, useGameStore } from '../domain/game/store/GameStore'
import { freeGameService } from '../domain/freeGame'
import { BitmapText } from '@pixi/react'

const textStyle = new TextStyle({
  fontSize: 48,
  lineHeight: 40,
  align: 'center',
  fill: '#FFF4D3',
  fontWeight: '600',
  fontFamily: 'Copperplate Gothic',
})
const winTextStyle = new TextStyle({
  fontSize: 48,
  lineHeight: 40,
  align: 'center',
  fill: '#FFF4D3',
  fontWeight: '900',
  fontFamily: 'Copperplate Gothic',
})

export const WinBoard = () => {
  const winTextRef = useRef<PixiContainer>(null)
  const spinTextRef = useRef<PixiText>(null)
  const [gameStatus, isFreeGame, isMainGameWin] = useGameStore(x => [x.gameStatus, x.isFreeGame, x.isMainGameWin])
  const enableBuyBonus = useFeatureToggleV2(FeatureToggleV2Type.enableBuyBonus)
  // 右側買 bonus 按鈕（或免費遊戲的剩餘局數）不存在時，文字要水平置中；
  // 判斷條件需與 BuyBonusButton 的 early-return 一致。
  const hasRightSlotContent = gameStatus !== GameStatus.Voucher && (enableBuyBonus || isFreeGame)
  const isViVn = language === 'VI_VN'
  const baseWinTextStyle = winTextStyle.clone()
  if (isViVn) {
    baseWinTextStyle.fontSize = 30
  }

  const winAmountOffsetY = isViVn ? -40 : 0

  useEffect(() => {
    if (spinTextRef.current) {
      winningService.setSpinText(spinTextRef.current)
    }
    if (winTextRef.current) {
      winningService.setWinTextContainer(winTextRef.current)
    }
    winningService.showSpinToWinText()
  }, [])

  return (
    <Container name="winBoardContainer" position={[540, 1470]}>
      <Image name="winBoard Image" anchor={0.5} x={0} y={-10} image="Image_winBar" />
      <Text name="goodLuck" x={hasRightSlotContent ? 75 : 0} y={-10} anchor={0.5} text={t('winBar_GoodLuck')} style={textStyle} ref={spinTextRef} />
      <Container name="winText" x={250} y={0} ref={winTextRef} alpha={0}>
        <Text name="win" x={-360 + winAmountOffsetY} y={-10} anchor={0.5} text={isMainGameWin ? t('main_control_panel_win') : t('main_control_panel_return')} style={baseWinTextStyle} />
        <Text name="winBarAmount" x={-120} y={-10} anchor={[0.5]} style={winTextStyle} />
      </Container>
      <BuyBonusButton />
    </Container>
  )
}

export const BuyBonusButton = () => {
  const [isEnable, setIsEnable] = useState(true)
  const [gameStatus, isFreeGame] = useGameStore(x => [x.gameStatus, x.isFreeGame])
  const enableBuyBonus = useFeatureToggleV2(FeatureToggleV2Type.enableBuyBonus)

  useEffect(() => {
    const subscription = threecomboolympusMachine.subscribe((snapshot) => {
      if (snapshot.matches('init game')) {
        setIsEnable(true)
      }
      else {
        setIsEnable(false)
      }
    })
    return () => {
      subscription.unsubscribe()
    }
  }, [])

  if (gameStatus === GameStatus.Voucher) {
    return null
  }

  // No dedicated "disabled" art exists for this game (caishenbaoxi swaps in a
  // 20lines placeholder), so the button is hidden outright when off.
  if (!enableBuyBonus && !isFreeGame) {
    return null
  }

  return (
    <Container name="buyBonusBtn" position={[-320, 0]}>
      { isFreeGame
        ? <FreeSpinRound />
        : (
            <Button
              name="buy bonus button"
              x={-220}
              y={-90}
              enabled={isEnable}
              visible={true}
              width={284}
              height={168}
              defaultView="btn_buyBonus_normal"
              hoverView="btn_buyBonus_hover"
              disabledView="btn_buyBonus_disable"
              pressedView="btn_buyBonus_click"
              onPress={() => {
                soundManager.play(SoundType.buttonConfirm)
                usePopupStore.setState({ isOpenBonusGamePopup: true })
              }}
            />
          )}
    </Container>
  )
}

export const FreeSpinRound = () => {
  const [freeGameIndex, currentFreeSpinNum] = useGameStore(x => [x.freeGameIndex, x.freeGameConut])

  const FreeSpinRoundRef = useRef<PixiContainer>()
  const currentRound = Math.max(0, currentFreeSpinNum - freeGameIndex - 1).toString()
  useEffect(() => {
    freeGameService.freeSpinRoundContainer = FreeSpinRoundRef.current as PixiContainer
  }, [])

  useEffect(() => { }, [freeGameIndex, currentFreeSpinNum, currentRound])

  return (
    <Container
      name="FreeSpinRound"
      x={-220}
      y={-90}
      ref={((el: PixiContainer | null) => FreeSpinRoundRef.current = el as PixiContainer)}
    >
      <Image
        name="FreeSpinRoundBG"
        image="FreeSpinRoundBG2"
        width={284}
        height={169}
        x={0}
        y={0}
      />
      <BitmapText
        name="freeSpinRoundTextContainer"
        anchor={[0.5, 0.5]}
        style={{ fontName: 'fontB', fontSize: 36 }}
        x={142}
        y={90}
        text={currentRound}
      />
    </Container>
  )
}
